import { api } from '../../app/api.js';

export default function CountrySelect({id, classes='', value = '', default_hide=false, onChange } = {}) {
    let $wrapper;
    let $select;

    const state = {
        countries: [],
        loading: true,
        error: null,
    };

    async function fetchCountries() {
        state.loading = true;
        updateUI();

        api.get({
            url: '/countries/',
            success: response => {
                state.countries = response.countries;
            }, error: () => {
                state.error = 'Failed to load countries';
            },
            complete: () => {
                state.loading = false;
                updateUI();
            }
        });
    }

    function updateUI() {
        if (!$select) return;

        if (!default_hide && state.loading) {
            $select.innerHTML = '<option>Loading...</option>';
            $select.disabled = true;
            return;
        } else if (state.loading) {
            $wrapper.classList.add('hidden');
            $select.disabled = true;
            return;
        }

        if (state.error && default_hide) {
            $wrapper.classList.add('hidden');
            return;
        } else if (state.error) {
            $select.innerHTML = `<option>${state.error}</option>`;
            $select.disabled = true;
            return;
        }

        $wrapper.classList.remove('hidden');

        $select.innerHTML = '<option value="">- optional -</option>' + state.countries
            .map(c => `<option value="${c.code}" ${c.code === value ? 'selected' : ''}>${c.name}</option>`)
            .join('');
        $select.disabled = false;
    }

    function handleChange(event) {
        const selected = event.target.value;
        if (onChange) onChange(selected);
    }

    return {
        render() {
            $wrapper = document.createElement('div');
            $wrapper.className = 'input'; // your wrapper for label, styling, etc.

            if (default_hide) {
                $wrapper.classList.add('hidden');
            }

            $wrapper.innerHTML = `
                <label for="${id}">Country</label>
                <select id="${id}" class="${classes}" name="country" autocomplete="off"></select>
            `;

            $select = $wrapper.querySelector('select');
            $select.addEventListener('change', handleChange);

            fetchCountries();

            return $wrapper;
        },

        onMount() {},
        onUnmount() {
            $select.removeEventListener('change', handleChange);
        },

        // optional helper to programmatically set value
        setValue(val) {
            value = val;
            if ($select) $select.value = val;
        },

        getValue() {
            return $select ? $select.value : value;
        }
    };
}
